import { Navigate } from 'react-router-dom';
import { useGetMe } from '@practium/features/api';
import { LoadingState } from '@practium/ui';

export function PendingPaymentGuard({ children }: Readonly<{ children: React.ReactNode }>) {
	const { data: me, isLoading } = useGetMe();

	if (isLoading) {
		return <LoadingState fullScreen />;
	}

	if (!me || me.isMaster || me.binding) {
		return <>{children}</>;
	}

	const paymentStatus = me.subscription?.paymentStatus;

	if (paymentStatus === 'pending') {
		return <Navigate to="/billing/success" replace />;
	}

	if (paymentStatus === 'failed') {
		return <Navigate to="/billing/error" replace />;
	}

	return <>{children}</>;
}
